import React from "react";
import { CFormText } from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  resetCurrentPresetFilters,
  saveCurrentPresetFilters,
  reset as resetState
} from "../redux/locationsSelectorSagas";
import { EditFilters } from "./Filters";
import { ArrowIcon } from "../../../assets/images/svg";
import { useError } from "../hooks/useError";

export function Edit({ setEdit }) {
  const dispatch = useDispatch();
  const stores = useSelector((state) => state.locations.currentPreset.filters.stores);

  const { errors } = useError(() => {
    setEdit(false);
    dispatch(resetState());
  });

  const save = (e) => {
    e.preventDefault();
    dispatch(saveCurrentPresetFilters());
  };

  const reset = (e) => {
    e.preventDefault();
    dispatch(resetCurrentPresetFilters());
  };

  const goBack = (e) => {
    e.preventDefault();
    dispatch(resetState());
    setEdit(false);
  };

  return (
    <div className="location-selector__edit">
      <div className="location-selector__edit-header">
        <div className="icon" onClick={goBack}>
          <ArrowIcon />
        </div>
        <div className="title">Edit Preset</div>
      </div>

      <div className="tabs__section location-selector__tabs__section-filters">
        <div className="location-selector__body">
          <EditFilters />
          {errors && <CFormText className="help-block">* {errors}</CFormText>}
        </div>

        <div className="location-selector__footer">
          <button className="button button--secondary button--no-outline" onClick={reset}>
            Reset
          </button>

          <button className="button button--primary" onClick={save} disabled={!stores.length}>
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}
